if (document.getElementById('page-recruit')) {
  const elmContent = document.querySelector('#recruit2')
  const elmSections = document.querySelectorAll('.recruitContent__sec')

  const update = () => {
    const scrollTop = window.scrollY + document.documentElement.clientHeight * 0.5
    const rect = elmContent.getBoundingClientRect()
    const contentMidpoint = rect.top + window.scrollY

    elmSections.forEach((el) => el.classList.remove('current'))
    if (scrollTop < contentMidpoint) {
      elmSections[0].classList.add('current')
    } else {
      elmSections[1].classList.add('current')
    }
  }

  window.addEventListener('scroll', update, { passive: true })
  update()

  // const adjustAnchor = () => {
  //   const links = document.querySelectorAll('.pageMv__list')

  //   links.forEach((link, index) => {
  //     const id = index + 1
  //     if (document.documentElement.clientWidth <= 768) {
  //       link.setAttribute('href', `#recruit${id}-sp`)
  //     } else {
  //       link.setAttribute('href', `#recruit${id}`)
  //     }
  //   })
  // }

  // window.addEventListener('resize', adjustAnchor)
  // adjustAnchor()
}
